import React from 'react';
import { type Attribute } from '@/common/types/attribute.type';

interface FeatureItem {
  id: number;
  title: string;
  value: string[];
}

interface ProductAttributesBoxSectionProps {
  data: Attribute[];
}

export const ProductAttributesBoxSection = ({
  data,
}: ProductAttributesBoxSectionProps) => {
  const items: FeatureItem[] = data.map((attribute) => ({
    id: attribute.attributeId,
    title: attribute.attributeName,
    value: attribute.values.map((item) => item.value),
  }));

  return (
    <>
      <h3 className="mt-7 mb-3 font-medium text-sm">ویژگی‌ها</h3>
      <div className="grid grid-cols-3 gap-2">
        {items.map((item, index) => {
          if (index > 5) return null;

          return (
            <div
              key={item.id}
              className="flex flex-col bg-gray-60 px-2 py-1 text-xs font-medium gap-0.5 rounded-md"
            >
              <h4 className="text-gray-500 line-clamp-1 leading-5">
                {item.title}
              </h4>
              <div className="flex">
                <span className="text-black-400 line-clamp-1 leading-5">
                  {item.value.join('، ')}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
